// extracted by mini-css-extract-plugin
export default {"header":"style_header__phPj5","title":"style_title__PDicY","install":"style_install__8zh5w"};